import React from "react";
import { Modal, Image } from "antd";
import Storelist from "../../Store/Actions";

const OpenImage = () => {
  const { PageStore, setImageViewer } = Storelist();

  return (
    <Modal
      open={PageStore.image_modal}
      onCancel={() => setImageViewer("")}
      footer={null}
      maskClosable={false}
      className="flex justify-center"
    >
      <Image
        src={PageStore.image_modal}
        alt="Employee"
        preview={false}
        height={300}
        width={300}
      ></Image>
    </Modal>
  );
};

export default OpenImage;
